import { render } from "./ProjectRazzoClientsCases.vue?vue&type=template&id=2e547126"
import script from "./ProjectRazzoClientsCases.vue?vue&type=script&lang=js"
export * from "./ProjectRazzoClientsCases.vue?vue&type=script&lang=js"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__